export const SET_INVOICE = "SET_INVOICE";
export const SET_NEW_CARD = "SET_NEW_CARD";
export const SET_FILE_CHOICE = "SET_FILE_CHOICE";
export const SET_CVV = "SET_CVV";
